// extracted by mini-css-extract-plugin
export default {"container":"SubLayout_container__HLP+F","sub_container":"SubLayout_sub_container__82CEh"};